import { graphql } from 'gatsby';
import React, { useState } from 'react';
import LitImage from './images/LitImage';
import LitStructuredText from './generic/LitStructuredText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
const ModularHeadingImageDropdownBox = ({ data }) => {
  const [dropdownOpen, setDropdownOpen] = useState();
  const {
    backgroundColor,
    noBottomPadding,
    noTopPadding,
    idContent,
    heading,
    dropdownTitle,
    dropdownBody,
    image,
  } = data;
  return (
    <div
      className={`modular-heading-image-dropdown-box-container ${backgroundColor} ${
        noBottomPadding && 'modular-padding-large-no-bottom'
      } ${noTopPadding && 'modular-padding-large-no-top'} ${
        !noBottomPadding && !noBottomPadding && 'modular-padding-large'
      }`}
      id={idContent}
    >
      <div className="modular-box-container White">
        <div className="image">
          <LitImage image={image} />
        </div>
        <div className="content">
          <LitStructuredText data={heading} basic />
          <div className="dropdown-container">
            <LitStructuredText data={dropdownBody} />
            <FontAwesomeIcon icon={faArrowDown} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModularHeadingImageDropdownBox;
export const fragment = graphql`
  fragment ModularHeadingImageDropdownBox on DatoCmsHeadingImageDropdownBox {
    internal {
      type
    }
    backgroundColor
    noBottomPadding
    noTopPadding
    idContent
    heading {
      value
    }
    dropdownTitle
    dropdownBody {
      value
    }
    image {
      gatsbyImageData
    }
  }
`;
